<template>
  <div class="weiby-container weiby-tabs">
    <ul :class="classes" class="weiby-tabs__tabs">
      <li
        v-for="(label, tabIndex) in tabs"
        :class="{ 'is-active': value === tabIndex }"
        :id="`tab-${tabIndex}`"
        :key="`tab-${tabIndex}`"
        class="weiby-tabs__tabs--tab"
        @click="setTab(tabIndex)"
      >
        {{ label }}
      </li>
    </ul>
  </div>
</template>

<script>
import WTabs from './WTabs';

export default WTabs;
</script>

<style lang="scss" scoped>
@import 'WTabs';
</style>
